import { createStackNavigator } from '@react-navigation/stack'
import {
  CommonStackParamList,
  renderCommonScreens,
} from 'navigation/common-screen'

export type MyPageStackParamList = CommonStackParamList

const Stack = createStackNavigator<MyPageStackParamList>()

export const MyPageStack = () => (
  <Stack.Navigator
    screenOptions={{ headerShown: false }}
    initialRouteName='UserDetailScreen'
  >
    {renderCommonScreens(Stack)}
  </Stack.Navigator>
)
